/** @format */

import React, { Component } from "react";


import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
// import { ProgressSpinner } from "primereact/progressspinner";
// import Navbar from "../Navbar";
import service from "../../utils/service";
import "primeflex/primeflex.css";
import { InputTextarea } from "primereact/inputtextarea";
import "../../style/news.css";
import { Toast } from "primereact/toast";
import { Accordion, AccordionTab } from "primereact/accordion";

class Version extends Component {
  constructor(props) {
    super(props);
    this.state = {
      displayVersionForm: false,
      newsLoading: true,
      versionNumber: "",
      features: "",
      productFeatures: [],
      demoURL: "",
    };
    
    this.toggleDisplay = this.toggleDisplay.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.saveVersionUpdate = this.saveVersionUpdate.bind(this);
    this.getVersionDetails = this.getVersionDetails.bind(this);
  }

  saveVersionUpdate() {
    this.toggleDisplay("displayVersionForm");
    let versionData = {};
    versionData.features = this.state.features;
    versionData.versionNumber = this.state.versionNumber;
    console.log("versionData", versionData)
    service.sendVersionDetails(versionData).then((response) => {});
    this.setState({
      features: "",
      versionNumber: "",
    });
  }

  toggleDisplay(val) {
    this.setState((prevState) => {
      return {
        [val]: !prevState[val],
      };
    });
  }

  getVersionDetails(version) {
    service
      .getVersionDetails(version)
      .then((response) => {
        var features = [];
        if (response.data !== "") {
          features = response.data.productFeatures;
        }
        this.setState({
          productFeatures: features,
          demoURL: response.data.demoLinkUrl,
        });
      })
      .catch((error) => {
        console.error(error);
      });
  }

  componentDidMount() {
    this.setState({
      newsLoading: true,
    });

    this.getVersionDetails("3.2");
  }
  handleChange(name, event) {
    this.setState({
      [name]: event.target.value,
    });
  }

  render() {
    return (
      <div className='main-box'>
        <Toast ref={(el) => (this.toast = el)} baseZIndex={20000} />
        <Button
          onClick={() => this.toggleDisplay("displayVersionForm")}
          label='Add Version Details'
          className='btn3 news-btn'
        />
        {this.state.displayVersionForm && (
          <div className='form-box clear' style={{ width: "50%" }}>
            <p className='head-form'>Add Version Details</p>
            <div className='p-fluid'>
              <div className='field'>
                <label htmlFor='verNo'>Version Number</label>
                <InputText
                  id='verNo'
                  value={this.state.versionNumber}
                  type='text'
                  onChange={(event) => {
                    this.handleChange("versionNumber", event);
                  }}
                />
              </div>
              <div className='field'>
                <label htmlFor='features'>Features</label>
                <InputTextarea
                  id='features'
                  rows={5}
                  value={this.state.features}
                  onChange={(event) => {
                    this.handleChange("features", event);
                  }}
                />
              </div>
            </div>
            <div>
              <Button
                onClick={() => this.toggleDisplay("displayVersionForm")}
                label='Close'
                className='p-button-sm btn3'
              />
              <Button
                onClick={() => this.toggleDisplay("displayVersionForm")}
                label='Add'
                className='p-button-sm btn3'
              />
              <div className='clear'></div>
            </div>
          </div>
        )}
        <Accordion className='clear' style={{ marginTop: "30px" }}>
          <AccordionTab header='3.0'>
            <h2 className='clear'>What's new in this version !!</h2>
            <div style={{ margin: "1rem" }}>
              {this.state.productFeatures?.map((feature, index) => (
                <div key={index}>
                  <h4>{feature.feature}</h4>
                  <ul>
                    {feature.productFeatureDetails?.map((featureDetail, index) => (
                      <li key={index}> {featureDetail.featureDetail} </li>
                    ))}
                  </ul>
                </div>
              ))}
              <a
                href={decodeURIComponent(encodeURIComponent(this.state.demoURL))}
                target='_blank'
                rel='noopener noreferrer'
                style={{ color: "#cccccc" }}
              >
                To watch demo click here
              </a>
            </div>
          </AccordionTab>
          <AccordionTab header='3.5'>
            <h2 className='clear'>What's new in this version !!</h2>
            <div style={{ margin: "1rem" }}>
              <h4>Channel</h4>
              <h4>Poll</h4>
            </div>
          </AccordionTab>
        </Accordion>
      </div>
    );
  }
}

export default Version;